import { StyledCaseReportSectionTitle } from 'src/components/atomsLegacy';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: 24px;
  width: 100%;
`;

export const Title = styled(StyledCaseReportSectionTitle)`
  text-transform: uppercase;
  margin: 10px 0 0;
`;

export const DetailContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const IdentityContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
